import compareVersions from 'compare-versions'

const MIN_DESKTOP_APP_VERSION_FOR_SLITE_PROTOCOL = '1.0.23'
const MIN_DESKTOP_APP_VERSION_FOR_WINDOWS_UPDATE = '1.1.9'
const MIN_DESKTOP_APP_VERSION_FOR_GOOGLE_AUTH = '1.1.10'

export function isAppDesktop() {
  return 'electron' in window
}

export function isSliteProtocolSupported() {
  return isMinimalElectronVersion(MIN_DESKTOP_APP_VERSION_FOR_SLITE_PROTOCOL)
}

export function isMinimalElectronVersion(version) {
  return (
    window.electron &&
    window.electron.version &&
    compareVersions(version, window.electron.version) <= 0
  )
}

export function isElectronWindowsUpdateFixed() {
  return isMinimalElectronVersion(MIN_DESKTOP_APP_VERSION_FOR_WINDOWS_UPDATE)
}

export function isElectronGoogleAuthSupported() {
  return isMinimalElectronVersion(MIN_DESKTOP_APP_VERSION_FOR_GOOGLE_AUTH)
}

export function isMac() {
  return window.navigator.platform.toUpperCase().indexOf('MAC') >= 0
}

export function isIos() {
  return (
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    // (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) test is needed for
    // iPad detection on iOS13 since 'MacIntel' is sent as navigation.platform value
  )
}

export function isAndroid() {
  return /Android/.test(navigator.userAgent)
}

export function isChrome() {
  return Boolean(window.chrome)
}

const BrowserHelpers = {
  isAppDesktop,
  isMac,
  isSliteProtocolSupported,
  isChrome,
  isElectronWindowsUpdateFixed,
  isElectronGoogleAuthSupported,
}

export default BrowserHelpers
